import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ChevronDown } from "lucide-react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface CustomCollapsibleItemProps {
  id: number;
  title: React.ReactNode;
  content: React.ReactNode;
  expanded: boolean;
  onToggle: () => void;
}

export const CustomCollapsibleItem: React.FC<CustomCollapsibleItemProps> = ({
  title,
  content,
  expanded,
  onToggle,
}) => {
  return (
    <Collapsible open={expanded} onOpenChange={onToggle}>
      <CollapsibleTrigger className="flex w-full items-center justify-between">
        {title}
        <ChevronDown
          className={cn(
            "h-5 w-5 text-grey-300 transition-transform duration-200",
            expanded && "transform rotate-180"
          )}
        />
      </CollapsibleTrigger>
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        transition={{ duration: 0.3, ease: [0.645, 0.045, 0.355, 1] }}
        animate={
          expanded ? { opacity: 1, height: "auto" } : { opacity: 0, height: 0 }
        }
      >
        <CollapsibleContent className="mt-2 whitespace-pre-line">
          {content}
        </CollapsibleContent>
      </motion.div>
    </Collapsible>
  );
};
